import { DocumentType } from "@/graphql/__generated__/graphql";

export const BadgeColourMap: Record<DocumentType, string> = {
  [DocumentType.Publication]: "bg-blue-100",
  [DocumentType.Contract]: "bg-green-100",
  [DocumentType.ServiceDescription]: "bg-yellow-100",
  [DocumentType.PriceForm]: "bg-purple-100",
  [DocumentType.Other]: "bg-gray-200",
};
